import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 0rem 2rem 4rem;
  max-width: 900px;
  margin: auto;
  background: #fff;
  color: #1f2937;
  line-height: 1.6;
  margin-top: 90px;

  h1,
  h2,
  h3 {
    color: #111827;
    margin-top: 2rem;
  }

  ul {
    margin-left: 1.5rem;
  }

  a {
    color: #3b82f6;
    text-decoration: none;
  }

  p {
    margin-top: 1rem;
  }
`;

const EULA: React.FC = () => (
  <Wrapper>
    <h1>End User License Agreement (EULA)</h1>
    <p>
      <strong>Last updated:</strong> February 5, 2026
    </p>

    <h2>1. License Grant</h2>
    <p>
      VendorOrbis ("Licensor") grants you ("Licensee") a limited,
      non-exclusive, non-transferable, revocable license to install and use the
      VendorOrbis mobile and web applications (the "Software") solely for your
      internal business use, subject to this EULA.
    </p>

    <h2>2. No Payment Processing</h2>
    <p>
      The Software is a bookkeeping and analytics tool. It does not process,
      transmit, or settle payments and is not a payment processor or financial
      institution. Any payment method labels or QR payment codes you add are
      stored for display and record-keeping only. If you enable Square card
      payments, Square (Block, Inc.) processes those card transactions.
    </p>
    <p>
      Your use of Square is governed by Square’s terms and privacy policy:
    </p>
    <ul>
      <li>
        <a href="https://squareup.com/legal" target="_blank" rel="noreferrer">
          Square Terms of Service
        </a>
      </li>
      <li>
        <a
          href="https://squareup.com/us/en/legal/general/privacy"
          target="_blank"
          rel="noreferrer"
        >
          Square Privacy Policy
        </a>
      </li>
    </ul>

    <h2>3. Permissions for Square payments</h2>
    <p>
      To connect Square readers and enable Tap to Pay, the mobile app may
      request device permissions. These are required only to make Square
      payments work:
    </p>
    <ul>
      <li>
        <strong>Location</strong> – required by Square to discover and connect
        nearby readers.
      </li>
      <li>
        <strong>Bluetooth / Nearby Devices</strong> – required to connect and
        communicate with Square readers.
      </li>
      <li>
        <strong>Microphone (Android)</strong> – required for some reader
        hardware types.
      </li>
      <li>
        <strong>Phone State (Android)</strong> – required by Square to identify
        the device for reader pairing.
      </li>
    </ul>

    <h2>4. License Restrictions</h2>
    <ul>
      <li>You may not copy, modify, or create derivative works of the Software.</li>
      <li>You may not reverse engineer, decompile, or disassemble the Software.</li>
      <li>You may not rent, lease, sell, or sublicense the Software.</li>
      <li>You may not remove or alter proprietary notices.</li>
    </ul>

    <h2>5. Ownership</h2>
    <p>
      The Software and all intellectual property rights are owned by Licensor
      or its licensors. This EULA does not grant you any ownership rights.
    </p>

    <h2>6. Updates</h2>
    <p>
      Licensor may provide updates, upgrades, or enhancements. Any updates are
      considered part of the Software and subject to this EULA.
    </p>

    <h2>7. Third-Party Services</h2>
    <p>
      The Software may rely on third-party services (for example, cloud hosting
      or AI processing). Your use of those services may be governed by their
      terms.
    </p>

    <h2>8. Disclaimer of Warranties</h2>
    <p>
      THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS
      OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
      PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
    </p>

    <h2>9. Limitation of Liability</h2>
    <p>
      TO THE MAXIMUM EXTENT PERMITTED BY LAW, LICENSOR WILL NOT BE LIABLE FOR
      ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING FROM
      YOUR USE OF OR INABILITY TO USE THE SOFTWARE.
    </p>

    <h2>10. Governing Law</h2>
    <p>
      This EULA is governed by the laws of the State of Louisiana, USA, without
      regard to conflict of laws principles.
    </p>

    <h2>11. Entire Agreement</h2>
    <p>
      This EULA, together with the Terms and Privacy Policy, constitutes the
      entire agreement between you and Licensor regarding the Software.
    </p>

    <p>&copy; {new Date().getFullYear()} VendorOrbis. All rights reserved.</p>
  </Wrapper>
);

export default EULA;
